import styled from "styled-components";

export const NewsContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  padding: 24px 0px;
  cursor: pointer;
`;

export const NewsOverviewContainer = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 32px;
`;

export const NewsOverviewMagazineContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 13px;
  cursor: pointer;
  border-radius: ${({ borderRadius = 12 }) => `${borderRadius}px`};

  div[backgroundurl] {
    height: 218px;
  }

  &:hover {
    outline-offset: 3px;
    outline: 6px solid ${({ theme }) => theme.border.brand}4d;
  }
`;

export const NewsOverviewShortListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  height: fit-content;
  cursor: pointer;
  border-radius: ${({ borderRadius = 12 }) => `${borderRadius}px`};

  ${({ flex, coverSize }) =>
    flex &&
    `
      div[backgroundurl] {
        flex: ${flex};
        height: ${coverSize};
      }
    `}

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`}
`;

export const NewsWrapper = styled.div`
  display: flex;
  padding: 21px 13px 13px 21px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 10px;
  width: 89%;
  height: 225px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: ${({ theme }) => theme.bg.secondary};
  box-shadow: ${({ theme }) => theme.orgchart.boxShadow};
`;

export const NewsTitle = styled.div`
  color: ${({ theme }) => theme.text.text}
  leading-trim: both;
  text-edge: cap;
  font-family: "PP Formula";
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  line-height: 9px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

export const NewsCardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  width: 100%;
  gap: 16px;
`;
